import {createSlice} from "@reduxjs/toolkit";

const initialEventsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  eventForEdit: undefined,
  lastError: null,
  eventAttendance: null,
  totalAttendace: 0,
  professionals: null,
  attendanceReport: null,
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const eventsSlice = createSlice({
  name: "events",
  initialState: initialEventsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getEventById
    eventFetched: (state, action) => {
      state.actionsLoading = false;
      state.eventForEdit = action.payload.eventForEdit;
      state.error = null;
    },
    // findEvents
    eventsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createEvent
    eventCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      if(action.payload.event !== null){
        var usr = action.payload.event;
        if(usr.id === undefined || usr.id === null || !usr.id){
          usr.id = 1000;
        }
        state.entities.push(usr);
      }
    },
    // updateEvent
    eventUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.event.id) {
          return action.payload.event;
        }
        return entity;
      });
    },
    // deleteEvent
    eventDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteEvents
    eventsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // eventsUpdateState
    eventsStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },

    //eventAttendanceFetched
    eventAttendanceFetched: (state, action) => {
      state.actionsLoading = false;
      state.eventAttendance = action.payload.eventAttendance;
      state.error = null;
      state.totalAttendace = action.payload.totalAttendace;
    },

    //eventAttendanceCreated
    eventAttendanceCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.totalAttendace = state.totalAttendace + 1;
      state.eventAttendance = action.payload.eventAttendance;
    },
    //eventAttendanceRemoved
    eventAttendanceRemoved: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.totalAttendace = state.totalAttendace - 1;
      state.eventAttendance = state.eventAttendance.filter(
        el => !action.payload.ids.includes(el.id)
      )
    },
    //eventAttendanceUpdated
    eventAttendanceUpdated: (state, action) => {
      state.actionsLoading = false;
      state.eventAttendance = action.payload.eventAttendance;
      state.error = null;
      state.totalAttendace = action.payload.totalAttendace;
    },

    //professionalsFetched
    professionalsFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.professionals = action.payload.professionals;
    },
    attendanceReportFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.attendanceReport = action.payload.attendanceReport;
    },
  }
});
